<template>
  <div>
    <span>Search </span><input type="text" v-model="searchtext" placeholder="検索ワード">
    <label>
      <span class="icon">
        <i class="fa fa-fw fa-play"></i>
      </span>
      <span class="select">
      <slot>
      <select v-model="searchType">
        <option value="id">ID</option>
        <option value="f_name + l_name">名前</option>
        <option value="f_name_kana + l_name_kana">読み</option>
        <option value="pref + address1 + address2">住所</option>
        <option value="tel1">電話番号</option>
        <option value="created_at">登録日</option>
      </select>
      </slot>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: ['searchtext'],
  data () {
    return {

    }
  },
  computed: {

  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style lang='scss' scoped>
input {
  padding: .5em;
  line-height:1.5;
  outline:none;
  font-size:16px;
  font-size:1rem;
  margin-right: .5rem
}
label {
  position: relative;
  width: 100px;
  border:1px solid #c0c0c0;
  color:#333;
  display: inline-block;
  .icon {
    position: absolute;
    right: .1em;
    top: 50%;
    color: lighten(#000000,50%);
    transform: translateY(-50%) rotate(90deg) scale(.7);
  }
}
</style>



// WEBPACK FOOTER //
// Search.vue?43f277fa